import Grid from '@mui/material/Grid';
import TextInput from '../../components/TextInput';
import React from 'react';
import useConfigStyles from '../../components/useConfigStyles';
import { Group } from '../../types/group';
import { useRulesContext } from '../../stores/rules-context';
import DropDownSelectList from '../../components/DropDownSelectList';
import { RuleIdentifier } from '../../types/rule';

interface GroupDetailsProps {
  group: Group;
  errors?: Record<string, string[]>;
  editable: boolean;
  onGroupUpdate?: (group: Group, fieldName?: string) => void;
}

function GroupDetails({ group, errors, editable, onGroupUpdate }: GroupDetailsProps): JSX.Element {
  const classes = useConfigStyles();
  const rulesContext = useRulesContext();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onGroupUpdate) {
      return;
    }
    const { name, value } = event.target;
    onGroupUpdate(
      {
        ...group,
        [name]: value,
      },
      name,
    );
  };

  const handleSetRules = (rules: RuleIdentifier[]) => {
    if (!onGroupUpdate) {
      return;
    }
    onGroupUpdate({ ...group, Rules: rules });
  };

  return (
    <Grid container alignItems='center' justifyContent='center' spacing={2} className={classes.container}>
      <Grid item className={classes.input} md={10}>
        <TextInput name='Name' label='Name' value={group.Name} onChange={handleInputChange} errors={errors} editable={editable} />
      </Grid>
      <Grid item className={classes.input} md={12}>
        <DropDownSelectList editable={editable} dataType='Rules' availableData={rulesContext.data} group={group} setData={handleSetRules} />
      </Grid>
    </Grid>
  );
}

GroupDetails.defaultProps = {
  errors: {},
  onGroupUpdate: () => {},
};

export default GroupDetails;
